import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalOverlay.module.scss";

const ModalOverlay = () => {
  const { absolutePosition } = useModal();
  return (
    <div
      className={styles["modal-overlay"]}
      data-absolute-position={absolutePosition}
    ></div>
  );
};

export default ModalOverlay;
